<div class="seperator"></div>
<div class="title" mat-dialog-title>Enable Scope3</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">Please schedule a daily Scope3 report and send to below email: </div>
        <div class="ias-email">
            {{scope3Email}}
        </div>
        <div class="template">
            <a href="https://rubii-images.s3.ap-southeast-2.amazonaws.com/templates/scope3.xlsx"
                target="_blank" data-cy="scope3-template-link">Download a sample report</a>
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
    </div>
</div>
